import { IoClose } from "react-icons/io5";

const FilterItem = ({ title, onRemove }) => {
  return (
    <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
      <p>{title}</p>
      <IoClose
        className="ml-2 cursor-pointer hover:text-red-500"
        onClick={onRemove}
      />
    </div>
  );
};

export default FilterItem;
